<template>
  <div class="mainIconSetting">
    <setting-header />

    <v-divider class="mainIconSetting_header-divider" />
    <section class="mainIconSetting_privew">
      <span class="mainIconSetting_privew-icon">
        <img
          v-if="selectedEmoji.startsWith('/')"
          class="mainIconSetting_emoji"
          :src="`/img/emoji${selectedEmoji}`"
        />
        <span v-else class="mainIconSetting_emoji">{{ selectedEmoji }}</span>
      </span>
      <span class="mainIconSetting_privew-label">選択中のアイコン</span>
    </section>
    <section class="mainIconSetting_body">
      <span
        v-for="(emoji, index) in emojiList"
        :key="index"
        v-ripple
        class="mainIconSetting_emoji-wrapper"
        :class="{
          'mainIconSetting_emoji-wrapper--selected': emoji === selectedEmoji,
        }"
        @click="handleEmoji(emoji)"
      >
        <img
          v-if="emoji.startsWith('/')"
          class="mainIconSetting_emoji"
          :src="`/img/emoji${emoji}`"
        />
        <span v-else class="mainIconSetting_emoji">{{ emoji }}</span>
      </span>
    </section>
    <v-divider class="mainIconSetting_footer-divider" />
    <v-btn
      class="mainIconSetting_change"
      color="text"
      :loading="changeLoading"
      :disabled="oldeSelected === selectedEmoji"
      @click="handleChange"
    >
      アイコンを変更する
    </v-btn>
  </div>
</template>

<script>
import SettingHeader from '../SettingHeader.vue';

export default {
  name: 'MainIconSetting',
  components: {
    SettingHeader,
  },
  data() {
    return {
      changeLoading: false,
      oldeSelected: '/emoji-0.svg',
      selectedEmoji: '/emoji-0.svg',
      emojiList: [
        '/emoji-0.svg',
        '🏘️',
        '🏚️',
        '🏡',
        '🏢',
        '🏣',
        '🏤',
        '🏥',
        '🏪',
        '🏭',
        '⛲',
        '🎡',
        '🎪',
        '⛽',
        '🚧',
        '👪',
        '🙍',
        '👼',
        '👍',
        '💪',
      ],
    };
  },

  methods: {
    handleEmoji(emoji) {
      this.selectedEmoji = emoji;
    },
    async handleChange() {
      try {
        this.changeLoading = true;
        await this.delayPromise(1000);
        this.oldeSelected = this.selectedEmoji;
      } catch (error) {
        console.error(error);
      } finally {
        this.changeLoading = false;
      }
    },
  },
};
</script>

<style lang="scss">
.mainIconSetting {
  position: relative;
  height: 100%;

  &_header-divider {
    margin-top: 15px;
    border-color: #cccccc !important;
  }
  &_footer-divider {
    border-color: #cccccc !important;
  }
  &_body {
    overflow-y: auto;
    display: flex;
    justify-content: flex-start;
    width: 440px;
    flex-wrap: wrap;
    height: 94px;
    padding: 10px 0;
  }
  &_emoji {
    &-wrapper {
      width: 32px;
      height: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 5px;
      border: solid 1px #eee;
      background-color: #fff;
      margin-right: 10px;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
      &--selected {
        background-color: #dbe2f3;
      }
    }
  }
  &_privew {
    padding: 10px 0;
    border-bottom: solid 1px rgba(0, 0, 0, 0.06);
    display: flex;
    align-items: center;

    &-icon {
      width: 40px;
      height: 40px;
      border-radius: 5px;
      border: solid 2px #ccc;
      background-color: #fff;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      .mainIconSetting_emoji {
        img {
          height: 19px;
        }
        font-size: 19px;
      }
    }
    &-label {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #666;
      margin-left: 10px;
    }
  }
  &_change {
    margin-top: 15px;
    &.theme--light.v-btn.v-btn--has-bg {
      height: 36px;
      border-radius: 5px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
      background-color: #0075c2;
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.14;
      letter-spacing: normal;
      text-align: left;
      color: #fff;
    }
    &.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
      background-color: #f3f3f3 !important;
      box-shadow: none;
      color: #ccc !important;
    }
  }
}
</style>
